/** History helpers for script-audio-align flow. */

const PANEL_KEY = 'script_audio_align_history_panel_open';

export function readScriptAudioAlignHistoryOpen(defaultOpen = true) {
  try {
    const v = localStorage.getItem(PANEL_KEY);
    if (v !== null) return v === 'true';
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined' && window.innerWidth < 640) return false;
  return defaultOpen;
}

export function writeScriptAudioAlignHistoryOpen(open) {
  try {
    localStorage.setItem(PANEL_KEY, open ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

export function formatScriptAudioAlignDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return String(iso);
  }
}

export function scriptAudioAlignStatusLabel(job) {
  const visual = job?.visual_plan_status;
  if (visual === 'preview_ready') return 'Preview ready';
  if (visual === 'confirmed') return 'Visuals saved';
  if (visual === 'suggested') return 'Visuals suggested';
  const st = String(job?.status || '').toLowerCase();
  if (st === 'failed') return 'Failed';
  if (st === 'running') return 'Running';
  if (st === 'completed') return 'Aligned';
  return st || 'Draft';
}

export function syncScriptAudioAlignSearchParams(prev, { storyId, jobId }) {
  const next = new URLSearchParams(prev);
  if (storyId) next.set('storyId', storyId);
  else next.delete('storyId');
  if (jobId) next.set('jobId', jobId);
  else next.delete('jobId');
  return next;
}

export function hydrateFormFromJobRequest(request = {}) {
  return {
    title: request.title || '',
    script: request.script || '',
    ttsProvider: request.tts_provider || 'openai',
    voice: request.voice || '',
    language: request.language || 'en',
  };
}
